import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'curbsideShipping',
})
export class CurbsideShippingPipe implements PipeTransform {
  transform(value: string, onConfirmation: boolean): string {
    if (value.toLowerCase() === 'curbside') {
      return !onConfirmation ? 'To your curbside - ' : 'To your curbside';
    }

    return !onConfirmation ? `${value} Shipping - ` : `${value} Shipping`;
  }
}
